<template>
  <div class="container-fluid">
    <h2 class="title-1">Санал хүсэлтүүд</h2>
    <div class="mt-3 text-right">
      <div class="btn-group" role="group" aria-label="Basic example">
        <button
          @click="onFilterChange('all')"
          type="button"
          class="btn btn-primary"
          :class="{'active': filter == 'all'}"
        >Бүгд</button>
        <button
          @click="onFilterChange('resolved')"
          type="button"
          class="btn btn-primary"
          :class="{'active': filter == 'resolved'}"
        >Шийдэгдсэн</button>
        <button
          @click="onFilterChange('unresolved')"
          type="button"
          class="btn btn-primary"
          :class="{'active': filter == 'unresolved'}"
        >Шийдэгдээгүй</button>
      </div>
    </div>
    <div v-if="inquiries !== null" class="card w-100 mt-3">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-top-campaign">
            <tbody>
              <tr
                class="inquiry-row"
                v-for="(inquiry, i) in inquiries"
                :key="i"
                @click="showDetail(inquiry)"
              >
                <td>{{ inquiry.email }}</td>
                <td>{{ inquiry.name }}</td>
                <td>{{ inquiry.phone }}</td>
                <td>
                  <div
                    class="overme"
                    data-toggle="tooltip"
                    data-placement="top"
                    :title="inquiry.body"
                  >{{ inquiry.body }}</div>
                </td>
                <td>{{ inquiry.created }}</td>
                <td>
                  {{ inquiry.status == 2 ? "Шийдэгдсэн" : "Шийдэгдээгүй" }}
                  <br>
                  <button
                    v-on:click.stop="changeStatus(inquiry)"
                    v-if="inquiry.status != 2"
                    class="btn btn-warning btn-sm"
                  >Шийдэх</button>
                  <button
                    v-on:click.stop="changeStatus(inquiry)"
                    v-if="inquiry.status == 2"
                    class="btn btn-info btn-sm"
                  >Болих</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="this.totalPages > 1" class="pagination-container">
        <paginate
          :page-count="totalPages"
          :container-class="'pagination'"
          :prev-text="'<'"
          :next-text="'>'"
          :click-handler="onPageClick"
        >
          <span slot="breakViewContent">
            <svg width="16" height="4" viewBox="0 0 16 4">
              <circle fill="#999999" cx="2" cy="2" r="2"></circle>
              <circle fill="#999999" cx="8" cy="2" r="2"></circle>
              <circle fill="#999999" cx="14" cy="2" r="2"></circle>
            </svg>
          </span>
        </paginate>
      </div>
    </div>
    <modal class="v--modal-box vue-dialog" width="60%" height="auto" name="inquiry-detail">
      <div class="inquiry__modal">
        <strong>Нэр</strong>
        {{ selectedInquiry.name }}
        <br>

        <strong>И-мэйл</strong>
        {{ selectedInquiry.email }}
        <br>

        <strong>Утас</strong>
        {{ selectedInquiry.phone }}
        <br>

        <strong>Нэр</strong>
        {{ selectedInquiry.name }}
        <br>

        <strong>Огноо</strong>
        {{ selectedInquiry.created }}
        <br>

        <br>

        <div class="inquiry-body">{{ selectedInquiry.body }}</div>
      </div>
      <div class="vue-dialog-buttons">
        <button
          @click="$modal.hide('inquiry-detail')"
          type="button"
          class="vue-dialog-button"
          style="flex: 1 1 100%;"
        >Close</button>
      </div>
    </modal>
  </div>
</template>

<style>
.overme {
  width: 180px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.inquiry-row {
  cursor: pointer;
}

.inquiry-body {
  max-height: 150px;
  overflow: auto;
}

.inquiry__modal {
  padding: 10px;
  font-size: 0.9em;
}
</style>

<script>
import InquiryService from "@/services/InquiryService";

export default {
  name: "InquiryList",

  created() {
    this.getInquiries();
  },

  data() {
    return {
      inquiries: null,
      filter: "all",

      pageNum: 1,
      totalPages: 0,
      selectedInquiry: {}
    };
  },

  methods: {
    getInquiries() {
      this.$store.dispatch("setLoading", true);
      const data = JSON.parse("{}");
      data.status =
        this.filter == "resolved" ? 2 : this.filter == "unresolved" ? 0 : null;
      InquiryService.getInquiryList({}, data, this.pageNum).then(response => {
        if (response.status == 200 && response.data.success == true) {
          this.totalPages = response.data.payload.totalPages;
          this.inquiries = response.data.payload.rows;
        }

        this.$store.dispatch("setLoading", false);
      });
    },

    onFilterChange(filter) {
      if (this.filter == filter) return;
      this.filter = filter;
      this.pageNum = 1;
      this.getInquiries();
    },

    changeStatus(inquiry) {
      this.$store.dispatch("setLoading", true);
      let data = JSON.parse("{}");
      data.id = inquiry.id;
      if (inquiry.status == 2) data.status = 0;
      else data.status = 2;

      InquiryService.changeStatus({}, data).then(response => {
        if (response.status == 200 && response.data.success == true) {
          if (response.data.payload.toast != null)
            this.showToast(response.data.payload.toast);
          inquiry.status = data.status;
          this.$store.dispatch("setLoading", false);
        }
      });
    },

    onPageClick(pageNum) {
      this.pageNum = pageNum;
      this.getInquiries();
    },

    showDetail(inquiry) {
      this.selectedInquiry = inquiry;
      this.$modal.show("inquiry-detail");
    }
  }
};
</script>